import { DataGrid, GridColDef } from '@material-ui/data-grid';
import Tippy from '@tippyjs/react';
import { nanoid } from 'nanoid';
import React, { ChangeEvent, KeyboardEvent, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { FaTrash } from 'react-icons/fa';
import { GoPencil } from 'react-icons/go';
import { toast } from 'react-toastify';
import { CancelButton, ConfirmButton } from '~/components/Buttons';
import { BuscaProduto, InputMoney, InputPeso } from '~/components/NovosInputs';
import { moedaFormatada } from '~/components/NovosInputs/InputMoney/formatMask';
import { formatCurrencyAsText, transformAsCurrency } from '~/utils/functions';
import { deleteItens, insertOrUpdate } from '~/utils/masterDetail';
import { calcularTotais } from '../../functions/calcularTotais';
import { useCadastroComposicao } from '../../hook/useCadastroComposicao';
import { useHandleFocus } from '../../hook/useFocus';
import { validaParaAdd } from '../../Validations';
import { ButtonRow, TableContainer } from './styles';

export const FormProduto: React.FC = () => {
  const {
    rows,
    formData,
    register,
    setValue,
    control,
    errors,
    handleSubmit,
    setRows,
    tipoPrecoComposicao,
    updateItems,
    setUpdateItems,
    getValues,
    clearErrors,
    masterDetail,
    setMasterDetail,
    valorTotalLoja,
    setValorTotalLoja,
    valorTotalComposicao,
    setValorTotalComposicao,
  } = useCadastroComposicao();
  const [idUpdate, setIdUpdate] = useState<number | string | undefined>(
    undefined,
  );
  const [produtoAtual, setProdutoAtual] = useState<any>();
  const { handleInputFocus } = useHandleFocus();

  const columns: GridColDef[] = [
    {
      field: 'id',
      headerName: 'Id',
      hide: true,
      width: 100,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: 'cod_loja',
      headerName: 'Loja',
      width: 60,
      flex: 1,
      hide: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params: { row: any }) => {
        const { row } = params;
        return (
          <>
            <span>{row.cod_loja}</span>
          </>
        );
      },
    },
    {
      field: 'cod_produto',
      headerName: 'Código',
      width: 110,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params: { row: any }) => {
        const { row } = params;
        return (
          <>
            <span>{row.cod_produto}</span>
          </>
        );
      },
    },
    {
      field: 'des_produto',
      headerName: 'Descrição',
      width: 350,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params: { row: any }) => {
        const { row } = params;
        return (
          <Tippy
            content={row.des_produto}
            arrow
            placement="bottom"
            animation="scale"
            appendTo={() => document.body}
            trigger="mouseenter focus"
            zIndex={99999}
            interactive
          >
            <span>{row.des_produto}</span>
          </Tippy>
        );
      },
    },
    {
      field: 'val_custo_rep',
      headerName: 'Custo Rep',
      disableColumnMenu: true,
      flex: 1,
      sortable: false,
      width: 260,
      align: 'right',
      renderCell: (params: { row: any }) => {
        const { row } = params;
        return (
          <>
            <span>{formatCurrencyAsText(row.val_custo_rep)}</span>
          </>
        );
      },
    },
    {
      field: 'qtd_est_atual',
      headerName: 'Estoque',
      flex: 1,
      width: 230,
      sortable: false,
      disableColumnMenu: true,
      align: 'right',
      renderCell: (params: { row: any }) => {
        const { row } = params;
        return (
          <>
            <span>
              {row.flg_ipv
                ? formatCurrencyAsText(row.qtd_est_atual || 0)
                : Number(row.qtd_est_atual || 0)}
            </span>
          </>
        );
      },
    },
    {
      field: 'qtd_composicao',
      headerName: 'Qtd. Comp.',
      width: 260,
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
      align: 'right',
      renderCell: (params: { row: any }) => {
        const { row } = params;
        return (
          <>
            <span>
              {row.flg_ipv
                ? formatCurrencyAsText(row.qtd_composicao || 0)
                : Number(row.qtd_composicao || 0)}
            </span>
          </>
        );
      },
    },
    {
      field: 'val_venda_composicao',
      headerName: 'Val. Venda',
      flex: 1,
      width: 200,
      disableColumnMenu: true,
      sortable: false,
      align: 'right',
      renderCell: (params: { row: any }) => {
        const { row } = params;
        return (
          <>
            <span>
              {tipoPrecoComposicao.value !== 2
                ? formatCurrencyAsText(row.val_venda || 0)
                : formatCurrencyAsText(row.val_venda_composicao || 0)}
            </span>
          </>
        );
      },
    },
    {
      field: 'acoes',
      headerName: 'Ações',
      width: 120,
      sortable: false,
      disableColumnMenu: true,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: { row: any }) => {
        const { row } = params;
        return (
          <>
            <ButtonRow
              type="button"
              onClick={() => onEditItem(row)}
              isBlocked={false}
              disabled={false}
              title="Editar"
            >
              <GoPencil size={20} style={{ color: '#72ab90' }} />
            </ButtonRow>
            <ButtonRow
              type="button"
              onClick={() => onRemoveItem(row)}
              isBlocked={false}
              disabled={false}
              title="Excluir"
            >
              <FaTrash size={20} style={{ color: '#e63c3c' }} />
            </ButtonRow>
          </>
        );
      },
    },
  ];

  const handleAddProdutoComposicao = (selected: any) => {
    const data = selected.map((item: any) => {
      return {
        label: `${item.cod_produto} - ${item.des_produto}`,
        cod_loja: item.cod_loja,
        value: item.cod_produto as string,
        cod_produto_compoe: item.cod_produto,
        des_produto: item.des_produto,
        des_unidade: item.des_unidade_venda,
        flg_ipv: item.flg_ipv,
        cod_associado: item.cod_associado,
        tipo_movimentacao: item.tipo_movimentacao,
        val_preco: item.val_preco,
        val_custo_rep: item.val_custo_rep,
        qtd_est_atual: item.qtd_est_atual,
      };
    });
    if (rows?.some((item: any) => item.cod_produto === data[0].value)) {
      const itemEncontrado = rows.find(
        (item: any) => item.cod_produto === data[0].value,
      );

      setProdutoAtual(itemEncontrado);
      setUpdateItems(true);
      setIdUpdate(itemEncontrado?.uuid);
      const qtde = itemEncontrado?.flg_ipv
        ? formatCurrencyAsText(itemEncontrado?.qtd_composicao)
        : Number(itemEncontrado?.qtd_composicao);

      setValue(
        'val_venda_composicao',
        formatCurrencyAsText(itemEncontrado?.val_venda_composicao),
      );
      handleInputFocus('qtd_composicao');
      return setValue('qtd_composicao', qtde);
    }
    setValue(
      'val_venda_composicao',
      formatCurrencyAsText(data[0].val_preco || 0),
    );
    setValue('cod_produto', data[0]);
    setProdutoAtual(data[0]);

    handleInputFocus('qtd_composicao');
  };

  const handleAddProduto = handleSubmit(async (data: any) => {
    try {
      const resValidation = validaParaAdd(
        data,
        formData,
        rows,
        tipoPrecoComposicao.value,
      );
      if (!resValidation.valid) return handleInputFocus(resValidation.campos);

      const uuid = nanoid();
      const insertRow = {
        uuid,
        id: uuid,
        cod_loja: data.cod_produto.cod_loja,
        cod_produto: data.cod_produto.value,
        des_produto: data.cod_produto.des_produto,
        qtd_composicao: transformAsCurrency(data.qtd_composicao),
        val_venda_composicao: transformAsCurrency(data.val_venda_composicao),
        val_venda: transformAsCurrency(data.cod_produto.val_preco),
        val_custo_rep: transformAsCurrency(data.cod_produto.val_custo_rep),
        qtd_est_atual: data.cod_produto.qtd_est_atual || 0,
        cod_produto_compoe: data.cod_produto.cod_produto_compoe,
        flg_ipv: data.cod_produto.flg_ipv,
      };
      const rowsDetail: any[] = await insertOrUpdate(
        'produtos',
        insertRow,
        masterDetail,
        setMasterDetail,
      );
      setRows([...rowsDetail]);

      const { totalLoja, totalComposicao } = calcularTotais(rowsDetail);

      const { val_preco } = getValues();
      setValorTotalLoja(totalLoja);

      handleClearForm();
      if (tipoPrecoComposicao.value === 1) {
        return setValorTotalComposicao(val_preco);
      }
      setValorTotalComposicao(totalComposicao);
    } catch (error) {
      toast.warning(
        'Não foi possível adicionar, verifique se todos os dados foram devidamente informados.',
      );
    }
  });

  const handleUpdateProduto = handleSubmit(async (data: any) => {
    if (idUpdate === undefined) return;
    const qtde = getValues('qtd_composicao');
    if (transformAsCurrency(qtde) <= 0 || data?.val_venda_composicao === '') {
      return toast.warning(
        'Os valores de Quantidade e Venda devem ser informados.',
      );
    }

    const items = Array.from(rows);
    const idx = items.findIndex((item) => item.uuid === idUpdate);

    if (!items[idx].flg_ipv && !Number.isInteger(Number(qtde))) {
      handleInputFocus('qtd_composicao');
      return toast.warn(
        `O produto ${data.cod_produto.label.slice(
          11,
        )} não é pesável, não permitido valor fracionado.`,
      );
    }

    const itemToUpdate = {
      ...items[idx],
      qtd_composicao: transformAsCurrency(qtde),
      val_venda_composicao: transformAsCurrency(data?.val_venda_composicao),
    };

    const rowsDetail: any[] = await insertOrUpdate(
      'produtos',
      itemToUpdate,
      masterDetail,
      setMasterDetail,
    );
    setRows(rowsDetail);

    const { totalLoja, totalComposicao } = calcularTotais(rowsDetail);

    const { val_preco } = getValues();
    setValorTotalLoja(totalLoja);

    handleClearForm();
    if (tipoPrecoComposicao.value === 1) {
      return setValorTotalComposicao(transformAsCurrency(val_preco));
    }
    setValorTotalComposicao(totalComposicao);
  });

  const onEditItem = (data: any) => {
    setUpdateItems(true);
    setProdutoAtual(data);
    setValue('cod_produto', {
      label: `${data.cod_produto} - ${data.des_produto}`,
      value: data.cod_produto_composicao,
    });
    setValue(
      'qtd_composicao',
      data.flg_ipv
        ? formatCurrencyAsText(data.qtd_composicao)
        : Number(data.qtd_composicao),
    );
    setValue(
      'val_venda_composicao',
      tipoPrecoComposicao.value !== 2
        ? formatCurrencyAsText(data.val_venda || 0)
        : formatCurrencyAsText(data.val_venda_composicao || 0),
    );
    handleInputFocus('qtd_composicao');
    setIdUpdate(data.uuid);
  };

  const onRemoveItem = (data: any) => {
    const updateRow: any = deleteItens(
      'produtos',
      data.uuid,
      masterDetail,
      setMasterDetail,
    );
    setRows(updateRow);
    const valVenda = transformAsCurrency(data.val_venda) || 0;
    const valVendaComposicao =
      transformAsCurrency(data.val_venda_composicao) || 0;
    const qtd = transformAsCurrency(data.qtd_composicao) || 0;

    const valorRemovidoLoja = valVenda * qtd;
    const valorRemovidoComposicao = valVendaComposicao * qtd;

    setValorTotalLoja(valorTotalLoja - valorRemovidoLoja);

    if (tipoPrecoComposicao.value !== 1) {
      setValorTotalComposicao(valorTotalComposicao - valorRemovidoComposicao);
    }
    handleClearForm();
  };

  const handleQtdComposicao = (value: any) => {
    if (produtoAtual?.flg_ipv) {
      return setValue('qtd_composicao', moedaFormatada(value, 3));
    }
    setValue('qtd_composicao', value);
  };

  const handleClearForm = () => {
    clearErrors();
    setUpdateItems(false);
    setIdUpdate(undefined);
    setProdutoAtual('');
    setValue('cod_produto', '');
    setValue('qtd_composicao', '');
    setValue('val_venda_composicao', formatCurrencyAsText(0));
    setTimeout(() => {
      return handleInputFocus('cod_produto');
    }, 300);
  };

  return (
    <>
      <Row>
        <Col sm={12} md={8}>
          <BuscaProduto
            id="cod_produto"
            tabIndex={0}
            label="Buscar Produto"
            placeholder="Selecione..."
            name="cod_produto"
            register={register}
            disabled={updateItems}
            isError={!!errors.cod_produto}
            control={control}
            buscaNasLojas={Number(formData.cod_loja.value)}
            setValue={setValue}
            customOptions={{
              hideBuscarPor: true,
              buscarPor: ['Produto'],
              showSelecionarItensContendo: false,
              filterByTipoMov: 0,
            }}
            getProduct={(selected: any) => {
              handleAddProdutoComposicao(selected);
            }}
          />
        </Col>
        <Col sm={12} md={2}>
          <InputPeso
            id="qtd_composicao"
            label="Qtd."
            placeholder="0"
            name="qtd_composicao"
            min={0.001}
            max={9999}
            decimals={3}
            maxLength={12}
            control={control}
            register={register}
            disabled={false}
            isError={!!errors.qtd_composicao}
            onKeyPress={async (event: KeyboardEvent) => {
              if (event.key === 'Enter') {
                if (tipoPrecoComposicao.value === 2) {
                  return handleInputFocus('val_venda_composicao');
                }
                if (updateItems) {
                  return handleUpdateProduto();
                }
                handleAddProduto();
              }
            }}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              handleQtdComposicao(e.target.value);
            }}
          />
        </Col>
        <Col sm={12} md={2}>
          <InputMoney
            id="val_venda_composicao"
            label="Val. Venda"
            placeholder="0,00"
            name="val_venda_composicao"
            min={0}
            max={9999}
            maxLength={15}
            control={control}
            register={register}
            disabled={tipoPrecoComposicao.value !== 2}
            isError={!!errors.val_venda_composicao}
            onKeyPress={async (event: KeyboardEvent) => {
              if (event.key === 'Enter') {
                if (updateItems) {
                  return handleUpdateProduto();
                }
                handleAddProduto();
              }
            }}
          />
        </Col>
      </Row>
      <Row md={12} sm={12} className="mt-4">
        <Col
          md={12}
          sm={12}
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <ConfirmButton
            onClick={() => {
              if (updateItems) {
                return handleUpdateProduto();
              }
              handleAddProduto();
            }}
          >
            Adicionar
          </ConfirmButton>

          <CancelButton
            onClick={() => {
              handleClearForm();
            }}
          >
            Cancelar
          </CancelButton>
        </Col>
      </Row>
      <Row>
        <TableContainer>
          <DataGrid
            rowsPerPageOptions={[5]}
            rows={rows}
            columns={columns}
            pageSize={5}
            autoHeight
            disableColumnSelector
            disableColumnFilter
            disableSelectionOnClick
            localeText={{
              noRowsLabel: 'Nenhum registro encontrado...',
              columnMenuLabel: 'Menu',
              columnMenuFilter: 'Filtrar',
              columnMenuHideColumn: 'Esconder',
              columnMenuUnsort: 'Não ordenar',
              columnMenuSortAsc: 'Ordernar ASC',
              columnMenuSortDesc: 'Ordernar DESC',
              columnMenuShowColumns: 'Mostrar columnas',
            }}
          />
        </TableContainer>
      </Row>
    </>
  );
};
